import Joi from 'joi-browser';
import moment from 'moment';
import _ from 'lodash';
import { localizeMessage } from './validateMessage';

export const DEFAULT_YEAR_START = 1920;
export const DEFAULT_YEAR_PLUS = 60;

export const customValidateDate = Joi.extend(joi => ({
  base: joi.string().allow(null, ''),
  name: 'base',
  rules: [
    {
      name: 'validateDate',
      validate(_params, value, state, options) {
        const [year, month, day] = stringToDate(value);
        const errorMessage = getMessageValidate(year, month, day);
        if (errorMessage) {
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
    {
      name: 'requiredDate',
      validate(_params, value, state, options) {
        const [year, month, day] = stringToDate(value);
        if (!year && !month && !day) {
          const errorMessage = localizeMessage.required;
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
  ],
}));

export const customValidateDateNotAllowEmpty = Joi.extend(joi => ({
  base: joi.string(),
  name: 'base',
  rules: [
    {
      name: 'validateDate',
      validate(_params, value, state, options) {
        const [year, month, day] = stringToDate(value);
        const errorMessage = getMessageValidate(year, month, day);
        if (errorMessage) {
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
    {
      name: 'requiredDate',
      validate(_params, value, state, options) {
        const [year, month, day] = stringToDate(value);
        if (!year && !month && !day) {
          const errorMessage = localizeMessage.required;
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
  ],
}));

export const customValidateYearMonth = Joi.extend(joi => ({
  base: joi.string().allow(null, ''),
  name: 'base',
  rules: [
    {
      name: 'validateDate',
      validate(_params, value, state, options) {
        const [year, month] = stringToDate(value);
        const errorMessage = getMessageValidateYearMonth(year, month);
        if (errorMessage) {
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
    {
      name: 'requiredDate',
      validate(_params, value, state, options) {
        const [year, month] = stringToDate(value);
        if (!year && !month) {
          const errorMessage = localizeMessage.required;
          return this.createError(
            'customMessage',
            { errorMessage },
            state,
            options
          );
        }
        return value;
      },
    },
  ],
}));

export const stringToDate = str =>
  !_.isString(str) ? '//'.split('/') : str.split('/');

export const getMessageValidate = (year, month, day) => {
  if (!year && !month && !day) {
    return '';
  }
  const yearEnd = moment()
    .add('year', DEFAULT_YEAR_PLUS)
    .get('year');
  const yearStart = DEFAULT_YEAR_START;
  if (year && !hasOnlyNumber(year)) {
    return '半角数字を入力してください。';
  }
  if ((year && Number(year) < yearStart) || Number(year) > yearEnd) {
    return `${yearStart}年〜${yearEnd}年の間で入力してください。`;
  }
  if ((month && !hasOnlyNumber(month)) || (day && !hasOnlyNumber(day))) {
    return '半角数字を入力してください。';
  }
  const isInvalid =
    !year ||
    !month ||
    !day ||
    parseInt(month) === 0 ||
    parseInt(day) === 0 ||
    !isValidDate(Number(year), Number(month), Number(day));
  if (isInvalid) {
    return '年月日を正しく入力してください。';
  }

  return '';
};

const getMessageValidateYearMonth = (year, month) => {
  if (!year && !month) {
    return '';
  }
  const yearEnd = moment()
    .add('year', DEFAULT_YEAR_PLUS)
    .get('year');
  const yearStart = DEFAULT_YEAR_START;
  if (year && !hasOnlyNumber(year)) {
    return '半角数字を入力してください。';
  }
  if ((year && Number(year) < yearStart) || Number(year) > yearEnd) {
    return `${yearStart}年〜${yearEnd}年の間で入力してください。`;
  }
  if (month && !hasOnlyNumber(month)) {
    return '半角数字を入力してください。';
  }
  const isInvalid =
    !year || !month || parseInt(month) === 0 || !isValidMonth(Number(month));
  if (isInvalid) {
    return '年月を正しく入力してください。';
  }

  return '';
};

export const hasOnlyNumber = str => {
  return /^\d+$/.test(str);
};

export const isValidDate = (year, month, day) => {
  return (
    month >= 1 && month <= 12 && day > 0 && day <= daysInMonth(month, year)
  );
};

const isValidMonth = month => {
  return month >= 1 && month <= 12;
};

export const convertDate = date => {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split('/');
  if (!year && !month && !day) {
    return null;
  }
  return `${year}/${`0${month}`.slice(-2)}/${`0${day}`.slice(-2)}`;
};

//月の日付が無効になる
export const daysInMonth = (month, year) => {
  switch (month) {
    case 2:
      return (year % 4 == 0 && year % 100) || year % 400 == 0 ? 29 : 28;
    case 9:
    case 4:
    case 6:
    case 11:
      return 30;
    default:
      return 31;
  }
};



// WEBPACK FOOTER //
// ./src/utilities/validateDateUtil.js